import { SVGProps } from 'react';

const DeleteIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.9501 11V17M14.9501 11V17M4.95007 7H20.9501M19.9501 7L19.0831 19.142C19.0472 19.6466 18.8214 20.1188 18.4512 20.4636C18.081 20.8083 17.5939 21 17.0881 21H8.81207C8.30621 21 7.81914 20.8083 7.44896 20.4636C7.07878 20.1188 6.85299 19.6466 6.81707 19.142L5.95007 7H19.9501ZM15.9501 7V4C15.9501 3.73478 15.8447 3.48043 15.6572 3.29289C15.4696 3.10536 15.2153 3 14.9501 3H10.9501C10.6849 3 10.4305 3.10536 10.243 3.29289C10.0554 3.48043 9.95007 3.73478 9.95007 4V7H15.9501Z"
      stroke="currentColor"
      strokeWidth="1.65"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DeleteIcon;
